import { render } from "./NotificationWidget.vue?vue&type=template&id=39568282&scoped=true"
import script from "./NotificationWidget.vue?vue&type=script&lang=js"
export * from "./NotificationWidget.vue?vue&type=script&lang=js"

import "./NotificationWidget.vue?vue&type=style&index=0&id=39568282&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39568282"]])

export default __exports__